exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pbc[data-v-3d5bb72b] {\n  padding: 0 0.052083rem;\n  margin-top: -0.182292rem;\n}\n.wl-table[data-v-3d5bb72b] {\n  margin-bottom: 0.03125rem;\n}\n.switch[data-v-3d5bb72b] {\n  float: right;\n  margin: 0 0.052083rem 0.052083rem 0;\n}", ""]);

// exports
